import { SessionStorageModel } from '../../../modules/storage/model';
import { PlansSlice } from '../organisms/slices/PlansSlice';
import * as React from 'react';

export const PrismicPlans: React.FC = (props) => {
  // Temporarily hidden until we replace with a version with the v2 plans
  return null;

  return <PlansSlice {...props} />;
};
